import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Img } from "../../constants/common/StyledGlobalConstants";
import FileIcon from "../../assets/icons/attachment-ic-16px-normal.svg";
import DisabledFileIcon from "../../assets/icons/attachment-ic-16px.svg";
import PropTypes from "prop-types";

const CustomisedAttach = styled.button`
  all: unset;
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  display: inline;
  text-decoration: underline;
  line-height: 14px;
  color: ${(props) => (props.disabled ? "#747474" : "#0077b4")};
  border-color: #0077b4;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  &:hover {
    text-decoration: ${(props) => (props.disabled ? "underline 1px" : "underline 2px")};
  }
  &:active {
    text-decoration: ${(props) => (props.disabled ? "" : "underline 1px")};
  }
  &:focus {
    border-radius: 2px;
    text-decoration: ${(props) => (props.disabled ? "" : "underline 1px")};
    outline: 2px solid #0077b4 !important;
  }
`;

const InteractiveContainer = styled.button`
  all: unset;
  display: inline-flex;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  border-radius: 2px;
  margin-bottom: ${(props) => (props.marginBottom || "1.5rem")};
  width: auto;
  
  &:focus {
    outline: ${(props) => (props.disabled ? "none" : "2px solid #0077b4")};
    outline-offset: 1px;
  }
  
  &:focus-visible {
    outline: ${(props) => (props.disabled ? "none" : "2px solid #0077b4")};
    outline-offset: 1px;
  }
`;
const AttachmentInput = ({ upload, reference, marginBottom, disabled, clearFilenameError, attachLinkRef }) => {
  const { t } = useTranslation("casesTranslation");

  const handleKeyDown = (e) => {
     if(e.key === "Enter" && !disabled) {
       reference.current?.click();
      }
       };

  const handleDivKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === " ") && !disabled) {
      e.preventDefault();
      clearFilenameError?.();
    }
  };

  return (
      <InteractiveContainer
        className="choose_file"
        marginBottom={marginBottom}
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        aria-label={t("Clear filename error")}
        onClick={clearFilenameError}
        onKeyDown={handleDivKeyDown}
      >
        <Img height={"16px"} width={"16px"} src={disabled ? DisabledFileIcon : FileIcon} aria-hidden="true" alt=""/>
          <input
            disabled={disabled}
            onChange={upload}
            type="file"
            id="choose_file"
            ref={reference}
            multiple
            style={{display:"none"}}
          />
          <CustomisedAttach
            disabled={disabled}
            ref={attachLinkRef}
            tabIndex={disabled ? -1 : 0}
            fontSize={"14px"}
            onKeyDown={handleKeyDown}
            onClick={(e) => {
              e.preventDefault();
              if(!disabled){
                reference.current?.click();
              }
            }}
            aria-label={t("Attach file")}
          >
            {t("Attach file")}
          </CustomisedAttach>
      </InteractiveContainer>
  );
};

AttachmentInput.propTypes = {
  upload: PropTypes.func.isRequired,
  reference: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  marginBottom: PropTypes.string,
  disabled: PropTypes.bool,
  clearFilenameError: PropTypes.func,
  attachLinkRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ])
};

export default AttachmentInput;
